export default "__VITE_ASSET__yz_J2MkM__"